export const customBox={
    position:'absolute',
    zIndex:11111,
    width: '100%',
    borderBottom: 1,
    padding:2,
    border:'1px solid #EEEEEE'
}